<template>
  <div id="app">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <el-button class="btn-primary" @click="edit()">修改</el-button>
          </div>
          <div class="ibox-content">
            <ul>
              <li class="mess_li">
                <span class="fileing">转诊医院：</span>
                <div class="filediv">{{referralName}}</div>
              </li>
              <li class="mess_li">
                <span class="fileing">医院地址：</span>
                <div class="filediv">{{address}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件

export default {
  name: 'app',
  data () {
    return {
      referralName: '',
      address: ''
    }
  },
  methods: {
    edit () {
      this.$router.push({path: '/edit'})
    }
  },
  created () {
    let self = this
        api.post(config.host + 'referral/getReferralByOrgId.do',{}).then((data) => {
          if (data.success == true) {
            var d = data.body;
            this.referralName = d.referralName;
            this.address=d.provinceName+d.cityName+d.districtName+d.address;
          }
    })
  }
}
</script>
<style>
.filediv{
    display:inline-block;
}
.mess_li {
    width: 100%;
    margin-top: 30px;
    list-style: none;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/referral/referralDetail.vue?2440a61b